export const CHAT_LIST_PADDING = {
  base: "spacing-3",
  "720px": "spacing-6",
  "960px": "spacing-8",
};
